import { FLIGHTS_COUNTER, FLIGHT_SECONDS_COUNTER } from './helpers/getEffectiveUsage/constants';

export { FLIGHTS_COUNTER, FLIGHT_SECONDS_COUNTER };

export const WEAR_LOG_PAGE_SIZE = 100;
